import { createAction } from 'redux-actions'

export const Set_Bot_Settings = 'set bot set'

export const setBotSetting = createAction(Set_Bot_Settings)
